/** Daily / weekly / monthly cadence for loan payment, accrual, and reset periods */
export type PeriodFrequency = '1D' | '1W' | '1M';

/**
 * Form-only sentinel for At Maturity schedule selection. Not a valid ExtendedDuration.
 * POST maps PaymentPeriod/AccrualPeriod to the loan maturity duration: Fixed term → Term;
 * Open term → InitialFixedTerm when present, otherwise omitted. Bullet loans always
 * serialize both periods to the resolved maturity duration.
 */
export const AtMaturityPeriod = 'AtMaturity' as const;
export type AtMaturityPeriod = typeof AtMaturityPeriod;

export type LoanSchedulePeriod = PeriodFrequency | AtMaturityPeriod;

export const LOAN_AT_MATURITY_DISPLAY = 'At Maturity';

export const PERIODIC_PERIOD_VALUES = ['1D', '1W', '1M'] as const satisfies ReadonlyArray<PeriodFrequency>;
